// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_j5-0";
export var buttonContainer = "_j5-3";
export var cancelButton = "_j5-4";
export var headerSection = "_j5-6";
export var headerTitle = "_j5-9";
export var messageSideLeft = "_j5-1";
export var messageSideRight = "_j5-2";
export var orderNumberContainer = "_j5-7";
export var orderNumberLabel = "_j5-8";
export var submitButton = "_j5-5";